module.exports = __webpack_public_path__ + "static/media/icons-maas.fb32f6c8.png";